import { Segmented, SegmentedProps, TabsProps } from 'antd';
import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

// services
import PageTitle from 'components/title/title';
import NotificationService from 'core/services/notification';
import ActionListHeaderComponent from '../listHeader';

const MainBoardPage: FunctionComponent = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const { t } = useTranslation();

	const [currentView, setCurrentView] = useState<'' | 'committees'>('');

	const tabItems: SegmentedProps['options'] = [
		{
			value: '',
			label: t('ACTIONS.BOARDS'),
		},
		{
			value: 'committees',
			label: t('ACTIONS.COMMITTEES'),
		},
	];

	useEffect(() => {
		setCurrentView(location.pathname.includes('committees') ? 'committees' : '');
	}, [location.pathname]);

	return (
		<>
			<Segmented
				size="large"
				block
				options={tabItems}
				className="custom mb-2"
				value={currentView}
				onChange={(value) => {
					setCurrentView(value.valueOf() as '' | 'committees');
					navigate(`/dashboard/actions/boards/${value}`);
				}}
			/>

			<Outlet />
		</>
	);
};

export default MainBoardPage;
